/*
 * @Author: Src
 * @Date: 2025-07-17 10:50:33
 * @LastEditTime: 2026-05-12 11:11:21
 * @LastEditors: Src
 * @FilePath: /work-station/src/models/car.model.ts
 * @Description: 头部注释配置模板
 */
import { ICarSPU, ECarSPU } from '@/common/interface/carSpu';

function pric(val: any) {
  if (!val) {
    return '';
  }
  const _val: any = Number(val);
  if (!_val) {
    return '';
  }
  return val;
}

export class CarSPU implements ECarSPU {
  id = 0;
  name = '';
  firstRegistrationDate = ''; // 首次上牌日期
  mileage = ''; // 里程
  carLocation = ''; // 车辆所在地
  transferTimes = ''; // 过户次数
  useTo = 1; // 用途：1-家用，2-营转非，3-单位用
  color = ''; // 颜色
  interiorColor = ''; // 内饰颜色
  highlights = ''; // 亮点
  description = ''; // 描述
  price = ''; // 价格
  certificateInfo = ''; // 登记证情况：1-齐全，2-丢失，3-补办中
  maintenanceInfo = ''; // 保养情况：1-4s店定期保养，2-非4s店定期保养，3-无定期保养
  exteriorInfo = ''; // 外观成色：1-极新，2-较新，3-一般，4-较差
  interiorInfo = ''; // 内饰情况：1-完好，2-有破损
  accidentInfo = ''; // 事故情况：1-无事故，2-有轻微剐蹭，3-有过大修
  sellingPoint = ''; // 销售卖点
  sequence = ''; // 排序
  auditStatus = ''; // 审核状态：0-未审核，1-已审核
  online = ''; // 线上状态：0-未上架，1-已上架
  isDel = ''; // 删除状态：0-未删除，1-已删除
  gearName = ''; // 变速箱类型
  liter = ''; // 排量
  vinCode = ''; // VIN码
  carImages = [] as any[]; // 车辆图片
  verificationImages = [] as any[]; // 车辆图片
  headerImage = [] as any[]; // 头部图片
  district_id = 0; // 区县id
  city_id = 0; // 城市id
  province_id = 0; // 省份id
  refitCharge = ''; // 加装价格
  evaluationPrice = ''; // 评估价格
  brand_id = 0; // 品牌
  series_id = 0; // 车系
  model_id = 0; // 车型
  brandName = ''; // 品牌名称
  seriesName = ''; // 车系名称
  modelName = ''; // 车型名称
  gdModelId = 0; // 车型
  vehicleSourceProcedureInformation = {
    certificateInfo: 1, // 登记证情况：1-齐全，2-丢失，3-补办中
    maintenanceInfo: 1, // 保养情况：1-4s店定期保养，2-非4s店定期保养，3-无定期保养
    purchaseInvoice: 1, // 购买发票：1-有，2-无
  };
  vehicleSourceInformation: any = {
    exteriorInfo: 1, // 外观成色：1-极新，2-较新，3-一般，4-较差
    interiorInfo: 1, // 内饰情况：1-完好，2-有破损
    accidentInfo: 1, // 事故情况：1-无事故，2-有轻微剐蹭，3-有过大修
  };
  vehicleSourcePriceInformation = {
    price: '', // 价格
    officialPrice: null, // 官方价格
    managerPrice: '', // 经理底价
    sellerPrice: '', // 销售底价

  };
  informationOnTheLocationOfTheVehicleSource = {
    vehicleSource: [], // 车源所在地
    carKey: '', // 钥匙数量
    carSource: '', // 车辆来源
    carPurchaser: '', // 车辆采购员
    carPurchaseDate: '', // 采购时间
    purchasePrice: '', // 采购价
    valuer: '', // 采购师
    procureProof: [], // 采购凭证（资源ID）

  };
  brandCarSeriesModels = {
    brandId: 0, // 品牌
    brand: '', // 品牌名称
    seriesId: 0, // 车系
    series: '', // 车系名称
    modelId: 0, // 车型
    modelName: '', // 车型名称
  };

  licenseInformationModule = {
    plateCityId: '', // 车牌城市
    trafficInsuranceDate: '', // 交强险到期日期
    commercialInsuranceDate: '', // 商业险到期日期
  };

  car_dimensions = {
    length: 0, // 长
    width: 0, // 宽
    height: 0, // 高
  };

  car_compartment_type = undefined; // 车厢形式
  max_total_mass = '';// kg 最大总质量
  wheelbase = ''; // 轴距 mm
  shafts_number = ''; // 轴数
  car_type = ''; // 车型

  static form(data: ICarSPU) {
    const carSPU = new CarSPU();
    carSPU.id = data.id;
    carSPU.name = data.name;
    carSPU.firstRegistrationDate = data.first_registration_date;
    carSPU.mileage = data.mileage;
    // carSPU.carLocation = data.car_location;
    carSPU.transferTimes = data.transfer_times;
    carSPU.useTo = data.use_to;
    carSPU.color = data.color;
    carSPU.interiorColor = data.interior_color;
    carSPU.highlights = data.highlights;
    carSPU.description = data.description;
    carSPU.price = data.price;
    carSPU.certificateInfo = data.certificate_info;
    carSPU.maintenanceInfo = data.maintenance_info;
    carSPU.exteriorInfo = data.exterior_info;
    carSPU.interiorInfo = data.interior_info;
    carSPU.accidentInfo = data.accident_info;
    carSPU.sellingPoint = data.selling_point;
    carSPU.sequence = data.sequence;
    carSPU.auditStatus = data.audit_status;
    carSPU.online = data.online;
    carSPU.isDel = data.is_del;
    carSPU.gearName = data.gear_name;
    carSPU.liter = data.liter;
    carSPU.vinCode = data.vin_code;
    carSPU.carImages = data.car_images;
    carSPU.verificationImages = data.verification_images;
    carSPU.headerImage = data.header_image;
    carSPU.refitCharge = data.refit_charge;
    carSPU.evaluationPrice = data.evaluation_price;
    carSPU.brand_id = data.brand_id;
    carSPU.series_id = data.series_id;
    carSPU.model_id = data.model_id;
    carSPU.brandName = data.brand;
    carSPU.seriesName = data.series;
    carSPU.modelName = data.model_name;
    carSPU.car_dimensions = data.car_dimensions;

    carSPU.car_compartment_type = data.car_compartment_type;
    carSPU.max_total_mass = data.max_total_mass;
    carSPU.wheelbase = data.wheelbase;
    carSPU.shafts_number = data.shafts_number;
    carSPU.car_type = data.car_type;

    const vehicleSourceProcedureInformation = {
      certificateInfo: data.certificate_info,
      maintenanceInfo: data.maintenance_info,
      purchaseInvoice: data.purchase_invoice,
    };
    const vehicleSourceInformation = {
      exteriorInfo: data.exterior_info,
      interiorInfo: data.interior_info ? +data.interior_info : '',
      accidentInfo: data.accident_info,
    };
    const brandCarSeriesModels = {
      brandId: data.brand_id, // 品牌
      brand: data.brand, // 品牌名称
      seriesId: data.series_id, // 车系
      series: data.series, // 车系名称
      modelId: data.model_id, // 车型
      modelName: data.model_name, // 车型名称
    };
    const vehicleSourcePriceInformation: any = {
      price: data.price,
      priceType: '', // 价格类型：1-固定价格，2-面议
      managerPrice: data.manager_price, // 经理底价
      sellerPrice: data.seller_price, // 销售底价
      officialPrice: data.official_price ? (Number(data.official_price) / 10000) : '', // 官方价格

    };
    const vehicleSource: any = [];
    if (data.province_id) {
      vehicleSource[0] = (data.province_id);
    }
    if (data.city_id) {
      vehicleSource[1] = (data.city_id);
    }
    if (data.district_id) {
      vehicleSource[2] = (data.district_id);
    }
    const informationOnTheLocationOfTheVehicleSource = {
      vehicleSource: vehicleSource.sort((a: any, b: any) => a - b), // 车源所在地
      carKey: data.car_key, // 钥匙数量
      carSource: data.car_source, // 车辆来源
      carPurchaser: data.car_purchaser, // 车辆采购员
      carPurchaseDate: data.car_purchase_date, // 采购时间
      purchasePrice: data.purchase_price, // 采购价
      valuer: data.valuer, // 采购师
      procureProof: data.procure_proof, // 采购凭证（资源ID）
    };

    const licenseInformationModule = {
      plateCityId: data.plate_city_id, // 车牌城市
      trafficInsuranceDate: data.traffic_insurance_date, // 交强险到期日期
      commercialInsuranceDate: data.commercial_insurance_date, // 商业险到期日期
    };

    carSPU.vehicleSourceProcedureInformation = vehicleSourceProcedureInformation;
    carSPU.vehicleSourceInformation = vehicleSourceInformation;
    carSPU.vehicleSourcePriceInformation = vehicleSourcePriceInformation;
    carSPU.informationOnTheLocationOfTheVehicleSource = informationOnTheLocationOfTheVehicleSource;
    carSPU.brandCarSeriesModels = brandCarSeriesModels;
    carSPU.licenseInformationModule = licenseInformationModule;


    return carSPU;
  }
}

export class JCarSPU implements ICarSPU {
  id = 0;
  shop_id = 0;
  name = '';
  first_registration_date = ''; // 首次上牌日期
  mileage = ''; // 里程
  car_location = ''; // 车辆所在地
  transfer_times = ''; // 过户次数
  use_to = 1; // 用途：1-家用，2-营转非，3-单位用
  color = ''; // 颜色
  interior_color = ''; // 内饰颜色
  highlights = ''; // 亮点
  description = ''; // 描述
  price = ''; // 价格
  certificate_info = ''; // 登记证情况：1-齐全，2-丢失，3-补办中
  maintenance_info = ''; // 保养情况：1-4s店定期保养，2-非4s店定期保养，3-无定期保养
  exterior_info = ''; // 外观成色：1-极新，2-较新，3-一般，4-较差
  interior_info = ''; // 内饰情况：1-完好，2-有破损
  accident_info = ''; // 事故情况：1-无事故，2-有轻微剐蹭，3-有过大修
  selling_point = ''; // 销售卖点
  sequence = ''; // 排序
  audit_status = ''; // 审核状态：0-未审核，1-已审核
  online = ''; // 线上状态：0-未上架，1-已上架
  is_del = ''; // 删除状态：0-未删除，1-已删除
  gear_name = ''; // 变速箱类型
  liter = ''; // 排量
  vin_code = ''; // VIN码
  brand_id = 0; // 品牌
  series_id = 0; // 车系
  model_id = 0; // 车型
  brand = ''; // 品牌名称
  series = ''; // 车系名称
  model_name = ''; // 车型名称
  purchase_invoice = ''; // 购买发票：1-有，2-无
  price_type = ''; // 价格类型：1-固定价格，2-面议
  province_id = 0; // 省份
  city_id = 0; // 城市
  district_id = 0; // 区县
  plate_city_id = 0; // 车牌城市
  car_images = [] as any[]; // 车辆图片
  verification_images = [] as any[]; // 车辆图片
  header_image = [] as any[]; // 头部图片
  commodity_code = ''; // 车源编码

  include_transfer_fee = '';

  refit_charge = ''; // 加装价格
  evaluation_price = ''; // 评估价格
  manager_price = ''; // 经理底价
  seller_price = ''; // 销售底价
  official_price = ''; // 官方价格
  car_key = ''; // 钥匙数量
  car_source = ''; // 车辆来源
  car_purchaser = ''; // 车辆采购员
  car_purchase_date = ''; // 采购时间
  purchase_price = ''; // 采购价
  valuer = ''; // 采购师
  procure_proof = ''; // 采购凭证（资源ID）
  traffic_insurance_date = ''; // 交强险到期日期
  commercial_insurance_date = ''; // 商业险到期日期
  series_name = ''; // 所属车系名称
  car_dimensions = {
    length: 0, // 长
    width: 0, // 宽
    height: 0, // 高
  };
  car_compartment_type = undefined;// 车厢形式
  max_total_mass = '';// kg 最大总质量
  wheelbase = ''; // 轴距 mm
  shafts_number = ''; // 轴数
  car_type = ''; // 车型
  static form(data: ECarSPU) {
    const carSPU = new JCarSPU();
    carSPU.id = data.id;
    carSPU.name = data.name;
    carSPU.first_registration_date = data.firstRegistrationDate;
    carSPU.mileage = data.mileage;
    carSPU.transfer_times = data.transferTimes;
    carSPU.use_to = data.useTo;
    carSPU.color = data.color;
    carSPU.interior_color = data.interiorColor;
    carSPU.highlights = data.highlights;
    carSPU.description = data.description;
    carSPU.price = data.price;
    carSPU.refit_charge = data.refitCharge;
    carSPU.evaluation_price = pric(data.evaluationPrice);

    carSPU.plate_city_id = data.licenseInformationModule.plateCityId;
    carSPU.traffic_insurance_date = data.licenseInformationModule.trafficInsuranceDate;
    carSPU.commercial_insurance_date = data.licenseInformationModule.commercialInsuranceDate;


    carSPU.car_key = data.informationOnTheLocationOfTheVehicleSource.carKey;
    carSPU.car_source = data.informationOnTheLocationOfTheVehicleSource.carSource;
    carSPU.car_purchaser = data.informationOnTheLocationOfTheVehicleSource.carPurchaser;
    carSPU.car_purchase_date = data.informationOnTheLocationOfTheVehicleSource.carPurchaseDate;
    carSPU.purchase_price = data.informationOnTheLocationOfTheVehicleSource.purchasePrice;
    carSPU.valuer = data.informationOnTheLocationOfTheVehicleSource.valuer;
    // carSPU.procure_proof = data.informationOnTheLocationOfTheVehicleSource.procureProof;


    const vehicleSource: any[] = data.informationOnTheLocationOfTheVehicleSource.vehicleSource || [];
    vehicleSource.sort((a, b) => a - b);
    if (vehicleSource.length) {
      carSPU.province_id = vehicleSource[0] || 0;
      carSPU.city_id = vehicleSource[1] || 0;
      carSPU.district_id = vehicleSource[2] || 0;
    }


    carSPU.certificate_info = data.vehicleSourceProcedureInformation.certificateInfo;
    carSPU.maintenance_info = data.vehicleSourceProcedureInformation.maintenanceInfo;
    carSPU.purchase_invoice = data.vehicleSourceProcedureInformation.purchaseInvoice;
    carSPU.car_images = data.carImages.map((res) => res.id);
    const headerImage = data.headerImage.map((res) => res.id);
    carSPU.header_image = headerImage[0];
    carSPU.verification_images = data.verificationImages.map((res: any) => res.id);

    carSPU.exterior_info = data.vehicleSourceInformation.exteriorInfo;
    carSPU.interior_info = data.vehicleSourceInformation.interiorInfo;
    carSPU.accident_info = data.vehicleSourceInformation.accidentInfo;
    carSPU.price = data.vehicleSourcePriceInformation.price;
    carSPU.manager_price = pric(data.vehicleSourcePriceInformation.managerPrice);
    carSPU.official_price = data.vehicleSourcePriceInformation.officialPrice;
    carSPU.seller_price = pric(data.vehicleSourcePriceInformation.sellerPrice);

    carSPU.selling_point = data.sellingPoint;
    carSPU.sequence = data.sequence;
    carSPU.audit_status = data.auditStatus;
    carSPU.online = data.online;
    carSPU.is_del = data.isDel;
    carSPU.gear_name = data.gearName;
    carSPU.liter = data.liter;
    carSPU.vin_code = data.vinCode;
    carSPU.brand_id = data.brandCarSeriesModels.brandId;
    carSPU.series_id = data.brandCarSeriesModels.seriesId;
    carSPU.model_id = data.brandCarSeriesModels.modelId;
    carSPU.car_dimensions = data.car_dimensions;

    carSPU.car_compartment_type = data.car_compartment_type;
    carSPU.max_total_mass = data.max_total_mass;
    carSPU.wheelbase = data.wheelbase;
    carSPU.shafts_number = data.shafts_number;
    carSPU.car_type = data.car_type;
    return carSPU;
  }
}

